import { RRIInputOption } from '../../form-inputs/interfaces/input-option.interface';

export class RRAvatarGeneratorShapesModel implements RRIInputOption<string> {
  id: string | number;
  value: string;
  female: string;
  male: string;
}
